import axiosInstance from "../axiosClient";

export const getConsultantsByBalance = async (params = {}) => {
  return axiosInstance.get("admins/consultants_by_balance", { params });
};

export const withdrawConsultantBalance = async (payload) => {
  // payload: { id, amount, description?, reference_id? }
  return axiosInstance.post("admins/withdraw_consultant_balance", payload);
};

export const getConsultantSettlements = async (consultant_id, params = {}) => {
  return axiosInstance.get("admins/consultant_settlements", {
    params: { consultant_id, ...params },
  });
};

export const getAllSettlements = async (params = {}) => {
  return axiosInstance.get("admins/settlements", { params });
};
